/**
 * 폼 검증에 걸리면 첫 번째 틀린 칸으로 스크롤하고 포커스한다(내 정보 수정·세미나 등록·쿠폰 팝업 공용).
 *
 * - 칸은 `data-field="이름"`(없으면 같은 id)으로 찾는다. 감싼 요소에 달아도 되고, 그 안의 첫 입력 칸(글 입력 우선, 없으면 버튼)으로 간다.
 * - 얼럿 모달을 닫으면 MUI 가 포커스를 원래 버튼으로 되돌리므로, 모달 뒤에는 {@link focusFieldAfterModal} 로 조금 늦게 옮긴다.
 */

const TEXT_FOCUSABLE: string =
    'input:not([type=hidden]):not([disabled]), textarea:not([disabled]), select:not([disabled]), [contenteditable="true"]';
const ANY_FOCUSABLE: string = `${TEXT_FOCUSABLE}, button:not([disabled]), [tabindex]:not([tabindex="-1"])`;

const escapeAttr = (value: string): string =>
    typeof CSS !== 'undefined' && typeof CSS.escape === 'function' ? CSS.escape(value) : value.replace(/"/g, '\\"');

/** 칸을 찾아 가운데로 스크롤하고 포커스한다. 찾았으면 true */
export const focusField = (field: string, root: ParentNode = document): boolean => {
    const host: HTMLElement | null =
        root.querySelector<HTMLElement>(`[data-field="${escapeAttr(field)}"]`) ?? document.getElementById(field);
    if (!host) return false;
    const target: HTMLElement = host.matches(ANY_FOCUSABLE)
        ? host
        : host.querySelector<HTMLElement>(TEXT_FOCUSABLE) ?? host.querySelector<HTMLElement>(ANY_FOCUSABLE) ?? host;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    target.focus({ preventScroll: true });
    return true;
};

/** 얼럿 모달이 닫히고 포커스가 되돌아간 뒤에 칸으로 옮긴다 */
export const focusFieldAfterModal = (field: string, delayMs: number = 300): number =>
    window.setTimeout(() => focusField(field), delayMs);
